import { Component, OnInit, Input, Output , EventEmitter , SimpleChanges , SimpleChange} from '@angular/core';
import {DataService} from '../data.service';

@Component({
  selector: 'app-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.css']
})
export class BadgesComponent implements OnInit {
  @Input() modules:number;
  @Input() score:number;
  @Input() isHome:boolean;
  @Input() currentScore:number;
  @Output() change:EventEmitter<boolean>=new EventEmitter<boolean>();
  userId:number=-1;
  bullsEye:number=0;
  consistency:number=0;
  scoreData={};
  latestAverageScoreBadge:number=0;

  constructor(private service:DataService) { }

  ngOnInit() {
    this.userId=localStorage.getItem("UserId")!=null ? parseInt(localStorage.getItem("UserId")) : -1;

        this.getBullEye();


  }

  ngDoCheck(){
    this.userId=localStorage.getItem("UserId")!=null ? parseInt(localStorage.getItem("UserId")) : -1;

  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.isHome==false){
      const name: SimpleChange = changes.currentScore;
     // console.log('prev score: ', name.previousValue);
     // console.log('got score: ', name.currentValue);
      this.currentScore=name.currentValue;
    }

 }

  getBullEye(){
    const inputJson= {
      "UserId":this.userId
    }

    if(this.userId==-1){
      return false;
    }

   // console.log(inputJson);
   // console.log("score is "+this.currentScore);
   // console.log("modules completed  "+this.modules);
    this.service.GetBullEye(inputJson)
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.bullsEye=result['Id'];
          this.getBadges(this.bullsEye);
          this.consistency=result['Batchno'];
          this.scoreData=result['Batch'][0];
         //  let myArr:number[]=[75,80,90,100]
         //  let big=myArr[0];
         //  for(var i=0;i<myArr.length;i++){
         //    if(this.scoreData['Isbatch'+myArr[i]]==true){
         //      if(myArr[i]>big){
         //        big=myArr[i];
         //      }
         //    }
         //  }
         // // console.log("Isbatch"+big);
         //  this.latestAverageScoreBadge=big;

        } else {
          this.service.alert(result['Message'],'error');
        }

      },
      (error)=>{
       // console.log(error);
      }
    )

  }


  getBadges(value){
   // console.log('bulls eye is '+value);
    this.bullsEye=value;

    let seriesArray:number[]=[1,2,3,5,8,10,15,20,25,30,40,50,60,75,100];


    for(let series of seriesArray){
      if(series==value && this.currentScore==100){
       // console.log('bulls eye badge found true')
        this.change.emit(true)

      }
      if(series==this.modules){
       // console.log('modules badge found true')
        this.change.emit(true)

      }
    }
  }



}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/badges/badges.component.ts